import { Eng2Chi } from "./_config";

/**
 * @description: 将string转换成Date
 * @param {string} v time
 * @return {*}
 */
const getDate = (v: string) => {
  return new Date(v);
}

/**
 * @description: 根据日期倒叙
 * @param {*} array
 * @return {*}
 */
export const sortByDate = (array: []) => {
  if (array && Array.isArray(array)) {
    let descArray = array?.sort((a, b) => getDate(b.output_at) - getDate(a.output_at))
    return descArray;
  } else {
    return []
  }
}

/**
 * @description: 切换中英文
 * @param {*} array
 * @param {string} type
 * @return {*}
 */
export const getFilterArray = (array: [], type: string) => {
  if (array.indexOf(Eng2Chi[type]) != -1) {
    return true;
  } else {
    return false;
  }
}
